import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

const TotalPremiumByPlanType = ({planTypeCosts, premiumByPlanTypePart}) => {

  // { name: 'Medical', y: 62245, sliced: slicedSections[0], color: '#F9B77B', currency: '$:val'},
  // { name: 'Vision', y: 37755, sliced: slicedSections[1], color: '#2B6BE4', currency: '$:val' },
  // { name: 'Dental', y: 46275, sliced: slicedSections[2], color: '#17BDBF', currency: '$:val' },

  let graphColorForType = {
    'Medical' : '#F9B77B',
    'Dental' : '#2B6BE4',
    'Vision' : '#17BDBF'
  };

  let graphData = [];
  planTypeCosts.forEach((cost) => {
    //push employee
    if (premiumByPlanTypePart.eeCost) {
      graphData.push({
        name: `Employee ${cost.planType}`,
        y: cost.employeeCost,
        sliced: cost.explode,
        currency: '$:val',
        color: graphColorForType[cost.planType] || "#080"
      })
    }
    //push employer
    if (premiumByPlanTypePart.empCost) {
      graphData.push({
        name: `Employer ${cost.planType}`,
        y: cost.employerCost,
        sliced: cost.explode,
        currency: '$:val',
        color: graphColorForType[cost.planType] || "#080"
      })
    }
    //push total
    if (premiumByPlanTypePart.totalCost) {
      graphData.push({
        name: `Total ${cost.planType}`,
        y: cost.totalCost,
        sliced: cost.explode,
        currency: '$:val',
        color: graphColorForType[cost.planType] || "#080"
      })
    }
  });

  // let graphData = planTypeCosts.map((cost) => {
  //   return {
  //     name: cost.planType,
  //     y: cost.totalCost,
  //     sliced: cost.explode,
  //     currency: '$:val',
  //     color: graphColors.pop() || 'red'
  //   }
  // });

  const options = {
    chart: {
      style: {
        fontFamily: 'Inter, sans-serif',
      },
      events: {
        render: function() {
          var chart = this,
            sum = 0;
  
          if (chart.textGroup) {
            chart.textGroup.destroy()
            chart.textGroup = undefined;
          }
  
          chart.textGroup = chart.renderer.g('textGroup').add().toFront()
          sum = (chart.series[0].data.length > 0) ? chart.series[0].data[0].total : 0;
          sum = Highcharts.numberFormat(sum, 0, '', ',');
          chart.myCustomText = chart.renderer.text(
              "$" + sum, (chart.plotWidth / 2) + chart.plotLeft, (chart.plotHeight/2.03) + chart.plotTop
            )
            .css({
              fontSize: '1.25em',
              fontWeight: '600',
            })
            .add(chart.textGroup);
          chart.textGroup.translate(-chart.myCustomText.getBBox().width / 1.65);
  
        },
      },
      type: 'pie',
      options3d: {
        enabled: false,
        alpha: 0,
      },
    },
    credits: { 
      enabled: false 
    },
    title: {
      text: null,
    },
    subtitle: {
      text: null,
    },
    tooltip: {
      formatter: function() {
        var number = Highcharts.numberFormat(this.point.y, 0, '', ',');
        return '<span style="color:#2F2B43">'+this.series.name+':<span style="font-weight:600">$'+number+'</span><span>'
      }
    },
    plotOptions: {
      pie: {
        innerSize: 80,
        slicedOffset: 20,
        depth: 0,
        dataLabels: {
          enabled: true,
          connectorColor: '#e6e6e6',
          connectorShape: 'straight',
          connectorWidth: 1.3,
          style: {
            fontWeight: 'normal',
            textOutline: 'none',
            fontSize: '0.8750em'
          },
          formatter: function() {
            var number = Highcharts.numberFormat(this.point.y, 0, '', ',');
            return '<span style="color:#2F2B43; font-weight:600">'+this.point.name+'</span></br><span style="color:#82808E; font-weight:500">$'+number+'</span>'
          }
        },
      },
    },
    series: [
      {
        name: 'Total Premium',
        borderRadius: 0,
        data: graphData
      }
    ]
  }

  return (    
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
    />
  )
};

export default TotalPremiumByPlanType;
